// import "babel-polyfill";
import 'lazysizes';
import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';
import { Fancybox } from "@fancyapps/ui";
import GraphComponent from "./components/graph-new.js";
import Nav from "./components/navigation.js";
import RelatedContent from "./components/related-content.js";
import Tabs from "./components/tabs.js";
import Widget from './components/widget.js';
import Calculator from './components/calculator.js';
import Sticky from './components/sticky.js';
// import Maps from './components/maps.js';
import Accordion from './components/accordion.js';
import Contact from './components/contact.js';
import Faq from './components/faq.js';
import News from './components/news.js';
import CookiesClass from './components/cookies.js';
// import Header from './components/header.js';
import Sale from './components/sale.js';
import lazySizes from "lazysizes";

var swiper = new Swiper(".js-slider", {
  modules: [Navigation, Pagination],
  centeredSlides: false,
  slidesPerView: 1,
  spaceBetween: 24,
  watchOverflow: true,
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  allowTouchMove: true,
  breakpoints: {
    320: {
      slidesPerView: 1.2
    },
    480: {
      slidesPerView: 1.5
    },
    600: {
      slidesPerView: 2.2
    },
    1024: {
      slidesPerView: 3,
      allowTouchMove: false
    }
  }
});

var reviewSlider = new Swiper(".js-review-slider", {
  modules: [Navigation, Pagination],
  centeredSlides: false,
  slidesPerView: 1,
  spaceBetween: 18,
  watchOverflow: true,
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  breakpoints: {
    480: {
      slidesPerView: 2
    },
    1024: {
      slidesPerView: 3,
      spaceBetween: 24,
    }
  }
});

const fetchApi = async () => {
  const goldRes = await fetch(`https://account.doijerkalff.nl/api/price/au/view`);
  const silverRes = await fetch(`https://account.doijerkalff.nl/api/price/ag/view`);

  const gold = await goldRes.json();
  const silver = await silverRes.json();

  window.localStorage.setItem('gold', JSON.stringify(gold))
  window.localStorage.setItem('silver', JSON.stringify(silver))
}

const saleFunctions = async () => {
  await fetchApi();

  setInterval(() => {
    fetchApi();
  }, 10000);

  document.querySelectorAll("[js-review]").forEach((element => {
    const reviews = document.querySelector(".__fbcw__bar-widget").cloneNode(true);
    element.replaceWith(reviews);
  }))

  document
    .querySelectorAll("[js-calculator]")
    .forEach((element) => {
      const calc = new Calculator(element)

      setInterval(() => {
        calc.getPrices();
      }, 5000);
    });
  document.querySelectorAll("[js-sale]")
    .forEach((element) => {
      const ele = new Sale(element)

      setInterval(() => {
        ele.getPrices();
      }, 5000);
    });
}

window.addEventListener("load", function () {
  lazySizes.init();
  window.lazySizesConfig = window.lazySizesConfig || {};
  lazySizesConfig.loadMode = 1;

  saleFunctions();

  new CookiesClass();
  
  document
    .querySelectorAll("[js-graph]")
    .forEach((element) => new GraphComponent(element));
  document
  .querySelectorAll("[js-header]")
  .forEach((element) => new Header(element));
  document
    .querySelectorAll("[js-faq]")
    .forEach((element) => new Faq(element));
  document
    .querySelectorAll("[js-related-content]")
    .forEach((element) => new RelatedContent(element));
  document
    .querySelectorAll("[js-navigation]")
    .forEach((element) => new Nav(element));
  document
    .querySelectorAll("[js-tabs]")
    .forEach((element) => new Tabs(element));
  document
    .querySelectorAll("[js-widget]")
    .forEach((element) => new Widget(element));
  document
    .querySelectorAll("[js-sticky]")
    .forEach((element) => new Sticky(element));
  // document
  //   .querySelectorAll("[js-maps]")
  //   .forEach((element) => new Maps(element));
  document
    .querySelectorAll("[js-accordion]")
    .forEach((element) => new Accordion(element));
  document
    .querySelectorAll("[js-news]")
    .forEach((element) => new News(element));
  document.querySelectorAll("[js-contact]")
    .forEach((element) => new Contact(element));
});

// Add language switcher active class
document.addEventListener("DOMContentLoaded", (event) => {
  
  // Get the parent element
  var parentElement = document.getElementById('js-language-switcher');

  // Get the child element
  var childElement = document.getElementById('js-language-switcher-trigger');

  // Add a click event listener to the child element
  childElement.addEventListener('click', function() {
    // Toggle the class on the parent element
    parentElement.classList.toggle('is-active');
  });

});

// Add timeline toggle collapse panes
document.addEventListener("DOMContentLoaded", (event) => {

  // Get all elements with the class 'toggle-button'
  var buttons = document.querySelectorAll('.js-timeline-toggle');

  // Add a click event listener to each button
  buttons.forEach(function(button) {
      button.addEventListener('click', function() {
          // Get the parent element of the clicked button
          var parent = button.parentElement;

          // Toggle the 'active' class on the parent element
          parent.classList.toggle('is-active');
      });
  });

});

document.addEventListener("DOMContentLoaded", (event) => {

  // Define the class name of the outer parent you're looking for
  var className = "js-process-item";

  // Add a click event listener to the document to handle clicks on all buttons
  document.addEventListener('click', function(e) {
      // Check if the clicked element has the class 'js-process-toggle'
      if (e.target.classList.contains('js-process-toggle')) {
          // Get the closest parent element with the specified class
          var outerParentWithClass = e.target.closest('.' + className);
          if (outerParentWithClass) {
              // Get all elements with the class 'js-process-item' and 'is-active'
              var activeItems = document.querySelectorAll('.' + className + '.is-active');
              // Close all other items with the 'is-active' class
              activeItems.forEach(function(item) {
                  if (item !== outerParentWithClass) {
                      item.classList.remove('is-active');
                  }
              });
              // Toggle the 'is-active' class on the clicked outer parent element
              outerParentWithClass.classList.toggle('is-active');
          }
      }
  });

});

document.addEventListener('DOMContentLoaded', function () {

  const checkboxes = document.querySelectorAll('.frm_checkbox input[type="checkbox"]');

  checkboxes.forEach(function(checkbox) {
      const spanElement = document.createElement('span');
      spanElement.textContent = '';
      checkbox.insertAdjacentElement('afterend', spanElement);
  });

});

document.addEventListener('DOMContentLoaded', function () {

  const radios = document.querySelectorAll('.frm_radio input[type="radio"]');

  radios.forEach(function(checkbox) {
      const spanElement = document.createElement('span');
      spanElement.textContent = '';
      checkbox.insertAdjacentElement('afterend', spanElement);
  });

});

document.querySelectorAll('.js-video').forEach(wrapper => {

  wrapper.addEventListener('click', function () {
    const videoId = this.getAttribute('data-video-id');
    const iframe = document.createElement('iframe');
    iframe.setAttribute('src', `https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0`);
    iframe.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture');
    iframe.setAttribute('allowfullscreen', 'true');
    iframe.classList.add('video-iframe');
    this.innerHTML = '';
    this.appendChild(iframe);
  });

});